import { render, staticRenderFns } from "./PullRefresh.vue?vue&type=template&id=3520d8c1&scoped=true&"
import script from "./PullRefresh.vue?vue&type=script&lang=js&"
export * from "./PullRefresh.vue?vue&type=script&lang=js&"
import style0 from "./PullRefresh.vue?vue&type=style&index=0&id=3520d8c1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3520d8c1",
  null
  
)

export default component.exports